/// <reference path="../../nativewind-augmentation.d.ts" />
// Copyright (c) Ping. All rights reserved.
//
// Placeholder pane for tabs we haven't built out yet (Keyboard,
// Sidebar, Voice & Video, Help & About). Surfaces a SettingsRow so
// the layout matches the rest of the modal and the user understands
// the tab exists but isn't wired.

import { Text, View } from "react-native";
import { SettingsRow } from "../SettingsRow";

export interface PlaceholderPaneProps {
	readonly title: string;
	readonly description: string;
	// Optional anchor for the per-pane guide.
	readonly testID?: string;
}

export function PlaceholderPane(props: PlaceholderPaneProps): JSX.Element {
	return (
		<View className="flex flex-col gap-4">
			<SettingsRow
				variant="hero"
				title={props.title}
				description={props.description}
				{...(props.testID !== undefined ? { testID: props.testID } : {})}
			>
				<Text className="text-[11px] leading-[15px] text-light-text-tertiary dark:text-[#6B7280]">
					This section will land in a follow-up slice.
				</Text>
			</SettingsRow>
		</View>
	);
}
